import * as constants from 'modules/auth/stateManagement/constants';
import {
  IAuthorizeUserFailed,
  IAuthorizeUserStarted,
  IAuthorizeUserSuccess,
  IGraphAPIConfig,
  ILoginUserFailed,
  ILoginUserStarted,
  ILoginUserSuccess,
  ITokenExpired,
} from './actions';
import { AuthErrorReason } from './state';

export const loginUserStarted = (): ILoginUserStarted => ({
  type: constants.LOGIN_USER_STARTED,
});

export const loginUserSuccess = (ssoToken: string, roles: string[]): ILoginUserSuccess => ({
  type: constants.LOGIN_USER_SUCCESS,
  payload: {
    ssoToken,
    roles,
  },
});

export const loginUserFailed = (
  errorMessage: string,
  reason: AuthErrorReason,
): ILoginUserFailed => ({
  type: constants.LOGIN_USER_FAILED,
  payload: {
    errorMessage,
    reason,
  },
});

export const authorizeUserStarted = (): IAuthorizeUserStarted => ({
  type: constants.AUTHORIZE_USER_STARTED,
});

export const authorizeUserSuccess = (): IAuthorizeUserSuccess => ({
  type: constants.AUTHORIZE_USER_SUCCESS,
});

export const authorizeUserFailed = (
  errorMessage: string,
  reason: AuthErrorReason,
): IAuthorizeUserFailed => ({
  type: constants.AUTHORIZE_USER_FAILED,
  payload: {
    errorMessage,
    reason,
  },
});

export const setGraphApiConfig = (access_token: string): IGraphAPIConfig => ({
  type: constants.SET_GRAPHAPI_CONFIG,
  payload: access_token,
});

export const tokenExpired = (ssoToken: string): ITokenExpired => ({
  type: constants.TOKEN_EXPIRED,
  payload: {
    ssoToken,
  },
});

export const actionTriggers = {
  loginUserStarted,
  loginUserSuccess,
  loginUserFailed,
  authorizeUserStarted,
  authorizeUserSuccess,
  authorizeUserFailed,
  setGraphApiConfig,
  tokenExpired,
};
